<template>
  <div>
    <van-row class="contentStyle ">
      <van-col
        span="2"
        style="line-height: 30px"
        @click="$router.push({ name: 'ChannelRoom' })"
      >
        <van-icon
          name="arrow-left"
          style="padding-top: 5px"
          color="#ffffff"
          size="27px"
        />
      </van-col>
      <van-col span="20" style="text-align: left">
        <div id="searchBar">
          <van-field
            v-model="queryChannel"
            style="
              padding: 0px 10px;
              line-height: 30px;
              height: 30px;
              background-color: #ffffff;
              color: #646566;
              border: 1px solid #ffffff;
              border-radius: 6px;
            "
            placeholder="频道列表"
          />
        </div>
      </van-col>
      <van-col span="2"> </van-col>
    </van-row>

      <div>
        <van-row v-for="(item, index) in channelList" :key="index" class="rowDesign"
            @click="joinForGroup(item.id,item.name)">   
                <van-col span="3" style="text-align: center;" class="channelsListStyle">
                    <img :src="item.avatar" class="imageStyle" />
                </van-col>
                <van-col span="15" style="text-align: left;">
                    <van-row class="channelsListRowStyle">
                    <span>{{item.name}}</span>
                    </van-row>
                </van-col>
                <van-col span="4" v-if="item.join == 0">
                  <span><van-button style="margin-top: 10px;" type="primary" size="mini">加入群组</van-button>
                  </span>
                </van-col>
        </van-row>
    </div>
    <van-dialog v-model="channelJoin" show-cancel-button :beforeClose="checkPermission" title="加入群组">
      <van-cell-group>
        <van-field type="password" v-model="channelPassword" placeholder="输入群组密码" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "ChannelSearch",
  data() {
    return {
      queryChannel: "",
      channelList:[],
      finishedText:false,
      channelJoin:false,
      channelPassword: "",
      channelName:"",
      channelId:"",
    };
  },

watch: {
    queryChannel: function (val) {
      this.searchChannel(val);
    },
  },
  methods: {
    searchChannel(queryChannel) {
      let that = this;
      that
        .$wonderChat({
          url: "api/group/search/" + queryChannel + "?type=1",
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          var data = res.data;
          if (data.code == 200) {
            that.channelList = res.data.dataList;
            if(that.channelList.length == 0){
              that.finishedText = true;
            }else{
              that.finishedText = false;
            }
          }
        });
    },
    joinForGroup(id,name){
      let that = this;
        that
        .$wonderChat({
          url: "api/group/member/join/"+id,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {
            password:that.channelPassword,
          },
        })
        .then((res) => {
          let resData = res.data;
          if(resData.code == 200){
              that.$router.push({ name: 'ChannelRoomUser', params: { account: id, groupname: name } });
              let data = {
                  channelId: id,
                  data: resData.data
                };
              that.$store.commit("updateChannelJoinStatus", data);
          } else{
              that.channelJoin = true;
              that.channelPassword = "";
              that.channelId = id;
              that.channelName = name;
          }
        });
    },
    checkPermission(action,done){
        let that = this;
        switch (action) {
          case 'confirm':
            if (!that.channelPassword) {
              this.$toast({
                type: 'warning',
                message: '输入群组密码'
              });
              done(false);
            }else{
                that
                .$wonderChat({
                  url: "api/group/member/join/"+that.channelId,
                  method: "post",
                  headers: {
                    "access-token": that.$store.state.wonder_chat_token,
                  },
                  data: {
                    password:that.channelPassword,
                  },
                })
                .then((res) => {
                  let resData = res.data;
                  if(resData.code == 200){
                    that.$toast({
                      message: "Success",
                      type: 'success',
                      onClose: function () {
                        that.$router.push({ name: 'ChannelRoomUser', params: { account: that.channelId, groupname: that.channelName } })
                        done()
                      }
                    });  
                  } else{
                      that.$toast.fail("密码错误");
                      done(false);
                  }
                });
            }
            break;
          case 'cancel':
            done();
            break;
        }
    },
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push("/login");
      }
    },
  },
  mounted: function () {
    this.isLogin();  
  },
};
</script>

<style scoped>
.contentStyle {
  background-color: #D02E27;
}

#searchBar {
  padding-top: 6px;
}

.channelsListStyle {
  text-align: left;
  padding-right: 10px;
}

.imageStyle {
  width: 40px;
  border-radius: 25px;
}

.channelsListRowStyle {
  padding-top: 12px;
  color: #000000;
}

.rowDesign {
  padding: 4px 10px;
  border-bottom: 1px solid #dcdee0;
}
</style>

<style>
#searchBar .van-field__control {
  color: #646566 !important;
  font-size: 14px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ChannelSearch.vue